import { connect } from 'react-redux'

import Cabinet from './Cabinet'
import { changeName, changeAvatar, fetchChangeAvatar, fetchChangeName } from '../top-panel/authorized-controls/authorizationActions'

const mapStateToProps = (state) => ({
  name: state.authorization.name,
  avatar: state.authorization.avatar,
  personId: state.authorization.personId
})

const mapDispatchToProps = (dispatch) => ({
  changeName: (name, personId) => dispatch(fetchChangeName(name, personId)),
  changeAvatar: (avatar, personId) => dispatch(fetchChangeAvatar(avatar, personId))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Cabinet)
